import { render, staticRenderFns } from "./ExtraFee.vue?vue&type=template&id=4b9f8188&scoped=true&"
import script from "./ExtraFee.vue?vue&type=script&lang=js&"
export * from "./ExtraFee.vue?vue&type=script&lang=js&"
import style0 from "./ExtraFee.vue?vue&type=style&index=0&id=4b9f8188&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f8188",
  null
  
)

export default component.exports